import { useContext, useEffect, useState } from "react";

import { SeasonContext } from "domain/contexts/SeasonContext";
import { SeasonInfo } from "../models/SeasonInfo";
import { fetchCurrentSeasonUseCase } from "../useCase/fetchCurrentSeasonUseCase";
interface CurrentSeasonStates {
  isLoading: boolean;
  currentSeason: SeasonInfo | null;
  error: Error | null;
  isFetching: boolean;
}

export const useCurrentSeason = () => {
  const seasonContext = useContext(SeasonContext);

  const fetchSeasonInfo = () => {
    setSeasonState((state) => ({ ...state, isFetching: true, error: null }));
    fetchCurrentSeasonUseCase
      .fetchCurrentSeason()
      .ifLeft((error) =>
        setSeasonState((state) => ({
          ...state,
          isFetching: false,
          error: error,
        }))
      )
      .ifRight((seasonInfo) => {
        seasonContext.updateSeasonId(seasonInfo?.id || 0);
        setSeasonState((state) => ({
          ...state,
          isLoading: false,
          currentSeason: seasonInfo,
        }));
      })
      .run();
  };
  const [seasonState, setSeasonState] = useState<CurrentSeasonStates>({
    currentSeason: null,
    error: null,
    isFetching: false,
    isLoading: false,
  });

  useEffect(() => {
    fetchSeasonInfo();
  }, []);

  return {
    viewState: seasonState,
    actions: {
      refresh: fetchSeasonInfo,
    },
  };
};
